import Vue from 'vue'

import Vuex, {Store} from 'vuex'

Vue.use(Vuex);

import pathify from './pathify'
import createPersistedState from 'vuex-persistedstate'

import SecureLS from "secure-ls";
const ls = new SecureLS({isCompression: false});

import form from './modules/form/form'
import func_data from './modules/form/func_data'
import form_data from './modules/data/form_data'
import general_data from './modules/data/general_data'

let storeOptions = {
    plugins: [
        pathify.plugin,
    ],
    modules: {
        form,
        form_data,
        general_data,
        func_data
    },
}

if(_.get(window, 'persist_state', true)){
    storeOptions.plugins.push(
        createPersistedState({
            key: window.slug,
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key)
                // getItem: key => window.localStorage.getItem(key),
                // setItem: (key, value) => window.localStorage.setItem(key,(value)),
                // removeItem: key => window.localStorage.removeItem(key)
            },
            paths: ['general_data', 'form_data'],
        })
    )
}

export default new Vuex.Store(storeOptions)
